import {addIcons} from 'ionicons'
import {
  addCircle,
  alert,
  arrowBack,
  arrowBackOutline,
  arrowDown,
  arrowForward,
  arrowUp,
  attach,
  calendar,
  call,
  caretDownOutline,
  caretForwardOutline,
  cash,
  checkboxOutline,
  checkmark,
  checkmarkCircleOutline,
  chevronBack,
  chevronDown,
  chevronDownOutline,
  chevronForward,
  chevronForwardOutline,
  close,
  closeCircle,
  closeCircleOutline,
  closeOutline,
  copy,
  create,
  document,
  ellipsisHorizontal,
  ellipsisVertical,
  eye,
  eyeOff,
  eyeOffOutline,
  helpCircleOutline,
  home,
  images,
  informationCircleOutline,
  locationSharp,
  logoAndroid,
  logoApple,
  logoLinkedin,
  menu,
  notifications,
  pause,
  person,
  personAdd,
  play,
  podium,
  refresh,
  sad,
  save,
  search,
  squareOutline,
  timeOutline,
  timer,
  warning,
} from 'ionicons/icons'

export function registerIcons() {
  addIcons({
    'add-circle': addCircle,
    alert,
    'arrow-back': arrowBack,
    'arrow-back-outline': arrowBackOutline,
    'arrow-dropdown': arrowDown,
    'arrow-dropup': arrowUp,
    'arrow-forward': arrowForward,
    attach,
    calendar,
    cash,
    call,
    'caret-down-outline': caretDownOutline,
    'caret-forward-outline': caretForwardOutline,
    checkmark,
    'checkmark-circle-outline': checkmarkCircleOutline,
    'chevron-back': chevronBack,
    'chevron-down': chevronDown,
    'chevron-down-outline': chevronDownOutline,
    'chevron-forward': chevronForward,
    'chevron-forward-outline': chevronForwardOutline,
    close,
    'close-circle': closeCircle,
    'close-circle-outline': closeCircleOutline,
    'close-outline': closeOutline,
    copy,
    create,
    document,
    'ellipsis-horizontal': ellipsisHorizontal,
    'ellipsis-vertical': ellipsisVertical,
    eye,
    'eye-off': eyeOff,
    'eye-off-outline': eyeOffOutline,
    'help-circle-outline': helpCircleOutline,
    home,
    'ios-home': home, // Legacy Ionic 4 icon name
    images,
    'information-circle-outline': informationCircleOutline,
    'location-sharp': locationSharp,
    'logo-android': logoAndroid,
    'logo-apple': logoApple,
    'logo-linkedin': logoLinkedin,
    menu,
    notifications,
    pause,
    play,
    person,
    'person-add': personAdd,
    podium,
    refresh,
    sad,
    save,
    search,
    'square-outline': squareOutline,
    'time-outline': timeOutline,
    timer,
    warning,
    'checkbox-outline': checkboxOutline,
  })
}
